import React, {useState} from 'react';
import Peep from 'react-peeps';
import Panel from '../panels/Panel';
import HairSelector from './Selectors/HairSelector';
import FaceSelector from './Selectors/FaceSelector';
import FacialHairSelector from './Selectors/FacialHairSelector';
import BodySelector from './Selectors/BodySelector';
import AccessorySelector from './Selectors/AccessorySelector';
import BackgroundSelector from './Selectors/BackgroundSelector';
import SkinSelector from './Selectors/SkinSelector';
import DiceIcon from '../icons/DiceIcon';
import { randomizeAvatar, CustomizeOptions, CustomizeStep } from './constants.mjs';

const AvatarCustomizer = ({setState, avatarState, setAvatarState}) => {
	const [selectedOption, setSelectedOption] = useState('Head');

	const renderSelector = (option) => {
		switch(option) {
			case 'Head':
				return <HairSelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			case 'Face':
				return <FaceSelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			case 'Facial Hair':
				return <FacialHairSelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			case 'Body':
				return <BodySelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			case 'Glasses':
				return <AccessorySelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			case 'Background':
				return <BackgroundSelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			case 'Skin':
				return <SkinSelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
			default:
				return <HairSelector setAvatarState={(data) => setAvatarState(data)} avatarState={avatarState}/>
		}
	
	}


    return <Panel title={'Customize your avatar'}>
			{/* Add some rectangles to indicate what step the user is on */}
			<div className={'grid place-items-center grid-cols-5 gap-10 justify-center mt-2'}>
				<div className={'relative w-24 h-3 col-start-2 rounded-sm shadow bg-staff bg-opacity-25'} />
				<div className={'relative w-24 h-3 col-start-3 rounded-sm shadow bg-staff bg-opacity-75'} />
				<div className={'relative w-24 h-3 col-start-4 rounded-sm shadow bg-staff bg-opacity-25'} />

			</div>
			<h1 className={'text-center font-gBlack text-3xl text-primary'}>Customize Your Look</h1>
			<p className={'text-center leading-5 font-gReg text-xl text-primary mb-2'}>Next, mix and match the elements below to customize your look, or tap the dice to generate a randomized look.</p>
			{/* Show the avatar */}
			<div className={'grid place-items-center'}>
				<Peep
					style={{
						width: 200,
						height: 200,
						justifyContent: 'center',
						alignSelf: 'center'
					}}
					circleStyle={avatarState.circleStyle} // Get to this later
					accessory={avatarState.accessory}
					body={avatarState.body}
					face={avatarState.face}
					hair={avatarState.hair}
					facialHair={avatarState.facialHair}
					strokeColor='#000000'
					viewBox={{ x: '90', y: '0', width: '1050', height: '1000' }}
					backgroundColor={avatarState.backgroundColor}
				/>
			</div>
			
			<div className={'py-4 grid grid-cols-1 divide-y-2 divide-gray-700 justify-center'}>
				{/* Buttons to set states */}
				<div className={'grid grid-cols-7 justify-center place-items-center gap-2 mb-2'}>
					<button 
						className={
							"flex bg-primary py-2 col-span-2 rounded-md font-gBold uppercase px-4 justify-center text-xl"
						}
						onClick={() => setState(CustomizeStep.USERNAME)}
						data-testid={`button-back`}
					>
						Back
					</button>
					<button
						className={
							"flex gap-1 bg-primary col-span-3 py-2 rounded-md font-gBold uppercase tracking-wider px-4 justify-center text-xl"
						}
						onClick={() => randomizeAvatar(avatarState, setAvatarState)}
						data-testid={`button-shuffle`}
					>
						<DiceIcon width={'25px'}/>
						Shuffle
					</button>
					<button 
						className={
							"flex bg-primary py-2 col-span-2 rounded-md font-gBold uppercase px-4 justify-center text-xl"
						}
						onClick={() => setState(CustomizeStep.FINALIZE)}
						data-testid={`button-save`}
					>
						Save
					</button>

				</div>
				{/* Show the different customizable fields */}
				<div className={'overflow-x-auto overflow-hidden no-scrollbar flex gap-6 pt-2'}>
					{CustomizeOptions.map((option) => {
						return <button key={option} onClick={() => setSelectedOption(option)}>
							<div className={`h-8 font-gBold whitespace-nowrap ${selectedOption === option ? 'text-staff' : 'text-black text-opacity-25'}`} key={option} >
									{option}
							</div>
						</button>
						})
					}
				</div>
				{/* Show the options for the selected field */}
				<div>
					{ renderSelector(selectedOption) }
				</div>
			</div>
		</Panel>
}

export default AvatarCustomizer;